import { FETCH_SORTING_OUTPUT_MATERIALS } from "./constants"
import { SortingOutputMaterial } from "./service/api"

export interface SortingOutputMaterialState {
  sortingOutputMaterials: SortingOutputMaterial[]
}

const initialState: SortingOutputMaterialState = {
  sortingOutputMaterials: [],
}

const sortingOutputMaterial = (
  state: SortingOutputMaterialState = initialState,
  action: any,
) => {
  switch (action.type) {
    case FETCH_SORTING_OUTPUT_MATERIALS:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export default sortingOutputMaterial
